
const zh_HK = {
    "form.isRequired": "必須輸入 {name}！",
    "form.OTPLabel": "電郵驗證碼",
    "form.OTPInputValidMessage": "驗證成功",
    "form.OTPInputInvalidMessage": "一次性驗證碼錯誤",
    "form.OTPWaitSecondsLabel": "再次傳送 ({waitOtpSeconds}s)",
    "form.OTPSendLabel": "傳送一次性驗證碼",
    "form.OTPSendSuccessLabel": "已成功將一次性驗證碼傳送至您的電郵地址！",
    "form.OTPTips": "請輸入正確的一次性驗證碼。",
    "form.selectInputLabel": "搜尋…",
    "form.uploadBtn": "上載",
    "form.uploadSizeTips": "檔案大小需小於5MB",
    "form.uploadTypeTips": "可上載的檔案類型：.png, .gif, .jpg, .jpeg, .pdf",
    "form.uploadNumTips": "必須上傳檔案",
    "form.isRequiredAccept": "必須點選同意方能繼續",
    "form.sendButton": "傳送",
    "form.isEmail": "請輸入正確的電郵地址",
    "form.isSerialNumber": "請於{name}輸入13個字元",
    "form.categoryPlaceholder": "選擇產品類型",
    "form.seriesPlaceholder": "選擇產品系列",
    "form.skuPlaceholder": "產品型號（SKU）",
    "form.sendSuccessMsg": "傳送成功！",

    "warrantyPeriod.checkTitle": "Check Warranty Period",
    "warrantyPeriod.checkDescription": "Please enter your email and serial number to check the warranty period.",
    "warrantyPeriod.emailLabel": "Email",
    "warrantyPeriod.emailPlaceholder": "Enter Email",
    "warrantyPeriod.serialNumberLabel": "Serial Number",
    "warrantyPeriod.serialNumberPlaceholder": "Enter Serial Number",
    "warrantyPeriod.checkButton": "Check",
    "warrantyPeriod.sendSuccessfulLabel": "Send Successfully! please check your email",
    "warrantyPeriod.checkNoRecordLabel": "Sorry, no record was found!",
}
export {
    zh_HK
}   